import { mainApi, queryFnNotifyWrapper } from 'modules/api';
import { withProvider } from 'modules/auth';
import { currentEnv } from 'modules/common';

import { getBalances, IGetBalancesResult } from '../api/getBalances';
import { stakeCacheTags } from '../stakeCacheTags';

export const { useGetBalancesQuery } = mainApi.injectEndpoints({
  endpoints: build => ({
    getBalances: build.query<IGetBalancesResult, void>({
      queryFn: queryFnNotifyWrapper<void, void, IGetBalancesResult>(
        async args =>
          withProvider({
            args,
            call: async ({ provider }) => {
              const data = await getBalances({
                walletAccount: provider.getWalletAccount(),
                client: provider.getClient(),
                env: currentEnv,
              });

              return { data };
            },
          }),
      ),
      providesTags: [stakeCacheTags.stake],
    }),
  }),
});
